const CaseStudyArchive = () => {

    document.addEventListener('DOMContentLoaded', function () {
        const container = document.getElementById('category-filter');
        const categories = JSON.parse(container.dataset.categories || '[]');
        let currentView = null;

        function renderSelect() {
            const currentUrl = window.location.pathname;

            const label = `<label for="sector-select" class="visually-hidden">Select a sector</label>`;
            const options = categories.map(opt => {
                const selected = currentUrl === new URL(opt.value, window.location.origin).pathname ? 'selected' : '';
                return `<option value="${opt.value}" ${selected}>${opt.label}</option>`;
            }).join('');

            container.innerHTML = label + `<select id="sector-select" class="archive-case-study__select">${options}</select>`;

            const select = container.querySelector('select');
            select.addEventListener('change', function () {
                if (this.value) {
                    window.location.href = this.value;
                }
            });

            currentView = 'select';
        }

        function renderButtons() {
            const currentUrl = window.location.pathname;

            const nav = document.createElement('nav');
            nav.className = 'archive-case-study__nav';
            nav.setAttribute('aria-label', 'Case study category navigation');

            const ul = document.createElement('ul');
            ul.className = 'archive-case-study__list';

            categories.forEach(opt => {
                const li = document.createElement('li');
                const a = document.createElement('a');
                a.href = opt.value;
                a.className = 'archive-case-study__link';
                if (currentUrl === new URL(opt.value, window.location.origin).pathname) {
                    a.classList.add('is-active');
                }
                a.textContent = opt.label;
                li.appendChild(a);
                ul.appendChild(li);
            });

            nav.appendChild(ul);
            container.innerHTML = '';
            container.appendChild(nav);

            currentView = 'buttons';
        }

        function handleResize() {
            const isDesktop = window.innerWidth >= 768;
            if (isDesktop && currentView !== 'buttons') {
                renderButtons();
            } else if (!isDesktop && currentView !== 'select') {
                renderSelect();
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);
    });
}

export default CaseStudyArchive;